import { Wording } from '@/types';

export const LOVE_WORDING_PL: Wording = {
  components_header_media_content: 'Audios',
  components_header_media_1: 'Medytacje',
  components_header_media_2: 'Podcast',
  components_header_text1: 'Przewodniki',
  components_header_text2: 'Blog',
  components_header_members: 'Członkowie',
  hero_text: 'Odkryj miłość przez gwiazdy',
  hero_button_text: 'Rozpocznij swoją podróż',
  components_ressources_section_title: 'MIŁOŚĆ I ASTROLOGIA',
  components_ressources_subheader_text: 'Twój niebiański zestaw narzędzi do romantycznego wglądu',
  components_ressources_span_text: 'Zanurz się w naszym wszechświecie podcastów i artykułów skupionych wokół miłości, zgodności zodiakalnej i kosmicznego połączenia. Niezależnie od tego, czy szukasz jasności bratniej duszy, czy rozszyfrowujesz wzorce swoich relacji, nasze zasoby poprowadzą Cię do głębszego zrozumienia poprzez gwiazdy.',
  components_ressources_card_1_title: 'Rozmowy o miłości zodiakalnej',
  components_ressources_card_1_text: 'Odkryj szczere odcinki podcastów, które zgłębiają emocjonalny język każdego znaku, zgodność miłosną, namiętność i rozwój osobisty w związkach.',
  components_ressources_card_2_title: 'Blog miłosny',
  components_ressources_card_2_text: 'Przeczytaj spostrzeżenia i refleksje na temat tego, jak każdy znak kocha, leczy i łączy. Od synastrii po romans planetarny, nasz blog jest Twoim przewodnikiem po astrologicznej miłości.',
  components_ressources_link: 'Odkryj więcej',
  components_notes_and_google_title_1: 'Astrologia romantyczna',
  components_notes_and_google_title_2: 'Nawyki miłosne',
  components_notes_and_google_title_3: 'Refleksje słuchaczy na temat miłości',
  components_review_google_text: 'Co mówią nasi słuchacze',
  media_content_section_title: 'PODCAST MIŁOŚĆ I ZODIAK',
  media_content_section_subheader_text: 'Prawdziwa rozmowa o kosmicznym romansie',
  text_media_1: 'Obejrzyj dogłębne, odkrywcze odcinki o astrologicznych dopasowaniach, wzorcach emocjonalnych i romantycznej dynamice.',
  text_media_2: '',
  media_content_section_button_more: 'Słuchaj teraz',
  text2_section_title: 'BLOG',
  text2_section_subheader_text: 'Astrologiczne historie miłosne i spostrzeżenia',
  text2_section_button_more: 'Załaduj więcej',
  components_text1_section_title: 'PRZEWODNIKI',
  components_text1_subheader_text: '',
  components_text1_span_text: '',
  components_text1_card_1_title: '',
  components_text1_card_1_text: '',
  components_text1_card_3_title: '',
  components_text1_card_3_text: '',
  components_text1_card_2_title: '',
  components_text1_card_2_text: '',
  components_text1_link: '',
  components_footer_text: 'Niech gwiazdy poprowadzą Twoją historię miłosną',
  components_footer_info: 'Informacje',
  components_footer_registration_number: 'Numer rejestracyjny',
  components_footer_legal: 'Prawny',
  components_footer_terms: 'Warunki i postanowienia',
  components_footer_privacy: 'Polityka prywatności',
  button_load_more: 'Załaduj więcej',
  page_media_2_content_hero_text: '',
  page_media_content_menu_antistress: '',
  page_media_content_menu_mindfulness: '',
  page_media_content_menu_energyboost: '',
  page_media_content_menu_mantra: '',
  page_media_1_content_hero_text: 'Miłość i Zodiak: Odcinki podcastu',
  page_media_content_menu_compatibility: 'Zgodność',
  page_media_content_menu_love: 'Miłość',
  page_text1_hero_text: '',
  page_text1_section_title: '',
  page_text1_subheader_text: '',
  page_text2_hero_text: 'Poznaj miłość poprzez astrologię',
  page_text2_section_title: 'Blog',
  page_text2_subheader_text: 'Artykuły',
  enter_email_title: 'Proszę wpisać swój adres e-mail, aby kontynuować',
  enter_email_placeholder_email: 'E-mail',
  enter_email_button_enter: 'Wchodzić',
  components_login_success_text: 'Logowanie pomyślne!',
  components_card_link_media_content: 'Słuchaj teraz',
  components_card_link_text2_content: 'Przeczytaj artykuły',
  components_card_link_text1_content: '',
  france: 'Francja',
  cyprus: 'Cypr',
  tag_podcast: 'Podcast',
  tag_meditation: 'Medytacja',
  page_media_content_menu_all: 'Wszystko',
};